import React from 'react';

const LoadingText = ({text}) => {
    return (
        <div className="w-full h-full fixed block top-0 left-0 bg-gray-900 opacity-90 z-50 flex items-center justify-center">
            <div className="flex items-center gap-x-2">
                <span className="text-lg">{text}</span>
                <div className="loader">Loading...</div>
            </div>
        </div>
    )
}

export default LoadingText;